import mapFunction from './mapResources';

export default mapFunction('work_operations', {
    isFetching: false,
    items: []
});